// @ts-nocheck
import * as Types from "../../../types/types";

import type { IndexSelectionData } from "types/index_selection";
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type IndexSelectionQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  tableId: Types.Scalars["ID"]["input"];
  options?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  preset?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  useConsolidation: Types.Scalars["Boolean"]["input"];
}>;

export type IndexSelectionQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTableIndexSelection: {
    __typename?: "IndexSelection";
    runAt: number;
    data: IndexSelectionData;
    isPrimaryInCluster?: boolean | null;
    scans: Array<{
      __typename?: "IndexSelectionScanDetail";
      id: string;
      whereExpression?: string | null;
      joinExpression?: string | null;
      combinedExpression: string;
      avgCallsPerMinute: number;
      avgCallsPerMinuteCluster?: number | null;
      parameterizedScanExpected?: boolean | null;
      queries: Array<{
        __typename?: "QuerySummaryStats";
        id: string;
        normalizedQuery: string;
        truncatedQuery: string;
        avgTime: number;
        callsPerMinute: number;
        pctOfTotal: number;
        databaseId: string;
        serverName: string;
      }>;
    }>;
  };
  getSchemaTableIndices: Array<{
    __typename?: "SchemaIndex";
    id: string;
    name: string;
    constraintDef?: string | null;
  }>;
};

export const IndexSelectionDocument = gql`
  query IndexSelection(
    $databaseId: ID!
    $tableId: ID!
    $options: String
    $preset: String
    $useConsolidation: Boolean!
  ) {
    getSchemaTableIndexSelection(
      databaseId: $databaseId
      schemaTableId: $tableId
      options: $options
      preset: $preset
      useConsolidation: $useConsolidation
    ) {
      runAt
      data
      isPrimaryInCluster
      scans {
        id
        whereExpression
        joinExpression
        combinedExpression
        avgCallsPerMinute
        avgCallsPerMinuteCluster
        parameterizedScanExpected
        queries {
          id
          normalizedQuery
          truncatedQuery
          avgTime
          callsPerMinute
          pctOfTotal
          databaseId
          serverName
        }
      }
    }
    getSchemaTableIndices(databaseId: $databaseId, schemaTableId: $tableId) {
      id
      name
      constraintDef
    }
  }
`;

/**
 * __useIndexSelectionQuery__
 *
 * To run a query within a React component, call `useIndexSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexSelectionQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      tableId: // value for 'tableId'
 *      options: // value for 'options'
 *      preset: // value for 'preset'
 *      useConsolidation: // value for 'useConsolidation'
 *   },
 * });
 */
export function useIndexSelectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    IndexSelectionQuery,
    IndexSelectionQueryVariables
  > &
    (
      | { variables: IndexSelectionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IndexSelectionQuery, IndexSelectionQueryVariables>(
    IndexSelectionDocument,
    options,
  );
}
export function useIndexSelectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndexSelectionQuery,
    IndexSelectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IndexSelectionQuery, IndexSelectionQueryVariables>(
    IndexSelectionDocument,
    options,
  );
}
// @ts-ignore
export function useIndexSelectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IndexSelectionQuery,
    IndexSelectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IndexSelectionQuery,
  IndexSelectionQueryVariables
>;
export function useIndexSelectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndexSelectionQuery,
        IndexSelectionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IndexSelectionQuery | undefined,
  IndexSelectionQueryVariables
>;
export function useIndexSelectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndexSelectionQuery,
        IndexSelectionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IndexSelectionQuery,
    IndexSelectionQueryVariables
  >(IndexSelectionDocument, options);
}
export type IndexSelectionQueryHookResult = ReturnType<
  typeof useIndexSelectionQuery
>;
export type IndexSelectionLazyQueryHookResult = ReturnType<
  typeof useIndexSelectionLazyQuery
>;
export type IndexSelectionSuspenseQueryHookResult = ReturnType<
  typeof useIndexSelectionSuspenseQuery
>;
export type IndexSelectionQueryResult = Apollo.QueryResult<
  IndexSelectionQuery,
  IndexSelectionQueryVariables
>;
